var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecycleB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Control/Reset/"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 3.08344C6.18019 3.08344 3.0835 6.18013 3.0835 10.0001C3.0835 13.8201 6.18019 16.9168 10.0002 16.9168C13.6732 16.9168 16.6778 14.0535 16.9032 10.4375C16.9204 10.1619 17.1578 9.95242 17.4334 9.9696C17.709 9.98678 17.9185 10.2241 17.9013 10.4997C17.6432 14.6395 14.2046 17.9168 10.0002 17.9168C5.62791 17.9168 2.0835 14.3724 2.0835 10.0001C2.0835 5.62785 5.62791 2.08344 10.0002 2.08344C12.9142 2.08344 15.4599 3.65814 16.8337 6.00062C16.9734 6.23882 16.8935 6.54517 16.6553 6.68486C16.4171 6.82456 16.1108 6.7447 15.9711 6.5065C14.7694 4.45746 12.545 3.08344 10.0002 3.08344Z",
    fill: "#5B5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5694 2.2383C17.844 2.26717 18.0433 2.5132 18.0144 2.78783L17.666 6.1029C17.589 6.83525 16.9329 7.36653 16.2006 7.28956L12.8855 6.94113C12.6109 6.91227 12.4116 6.66623 12.4405 6.39161C12.4694 6.11698 12.7154 5.91774 12.99 5.94661L16.3051 6.29504C16.4882 6.31428 16.6522 6.18146 16.6714 5.99837L17.0199 2.6833C17.0487 2.40867 17.2948 2.20944 17.5694 2.2383Z",
    fill: "#5B5C5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleB);
export default __webpack_public_path__ + "static/media/RecycleB.1d8c441c3dd7c6b4f02f16a2642fe521.svg";
export { ForwardRef as ReactComponent };